const LEADING_DOUBLE_SLASH = /^\/[\\/]/

export const sameOriginPath = (value) => {
  if (typeof value !== 'string' || value === '') return null
  try {
    const target = new URL(value, window.location.origin)
    if (target.origin !== window.location.origin) return null
    if (LEADING_DOUBLE_SLASH.test(target.pathname)) return null
    return `${target.pathname}${target.search}${target.hash}`
  } catch (error) {
    return null
  }
}
